<template>
  <span class="container">
    <input :type="formType" :name="name" class="input" :style="formSize" :placeholder="placeholderText"
           :disabled="isDisable"
           :autocomplete="autocompleteData" @change="updateValue" v-model="value"
           :class="additionalCss">
  </span>
</template>

<script>

export default {
  props: ['name', 'placeholder', 'usePlaceholderIcon', 'size', 'autocomplete', 'isPassword', 'default', 'isDisable', 'isError', 'h'],
  data () {
    return {
      value: null,
      placeholderText: null
    };
  },
  created: function () {
    console.log(this.$isAdmin());

  },
  mounted: function () {
    this.initialize();
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    default: function () {
      this.initialize();
    },
    value: function (value) {
      this.$emit('callback', this.name, value);
    },
    placeholder: function () {
      this.initialize();
    }
  },
  computed: {
    formType: function () {
      if (this.isPassword === true) {
        return 'password';
      } else {
        return 'text';
      }
    },
    autocompleteData: function () {
      return this.autocomplete;
    },
    formSize: function () {

      let w = this.$store.getters['wrm/width'];

      console.log(w, this.$variables.mediaScreenIsPC);

      if (w <= this.$variables.mediaScreenIsPC) {
        return 'width: 100%';
      } else {
        return 'width:' + this.size + 'px';
      }

    },
    additionalCss: function () {

      let css = [];

      if (this.isDisable) {
        css.push('is-disable');
      }

      if (this.usePlaceholderIcon) {
        css.push('use-icon');
      }

      if (this.h === 's') {
        css.push('height-s');
      } else {
        css.push('height-m');
      }

      if (this.isError) {
        css.push('is-error');
      }

      if (this.$isAdmin()) {
        css.push('border-default');
      } else {
        css.push('border-front');
      }

      return css;
    },
  },
  methods: {
    initialize: function () {

      let value = {key: this.name, value: this.default};

      this.$store.dispatch('formValues/setFormData', value).then();

      this.value = this.default;

      if (this.isDisable) {
        if (typeof this.placeholder === 'undefined') {
          this.placeholderText = '(未入力)';
        } else {
          this.placeholderText = this.placeholder;
        }
      } else {
        this.placeholderText = this.placeholder;
      }

    },
    updateValue: function (e) {

      let value = {key: this.name, value: e.target.value};

      this.$store.dispatch('formValues/setFormData', value).then();

    }
  }
};

</script>

<style lang="scss" scoped>

  @import '../../assets/styles/_variable.scss';

  .container {
    text-align: left;
  }

  .input {
    display: inline-block;
    border-radius: 4px;
    padding-left: 15px;
    background: #fff;
  }

  /** use computed */
  .is-disable {
    background: #f8f8f8;
    color: #444;
  }

  .is-error {
    border: 1px solid #DD4B39;
    background: rgba(237, 159, 150, 0.28);
    color: #DD4B39;
  }

  .use-icon {
    font-family: "Font Awesome 5 Free";
    font-weight: 600;
  }

  .height-m {
    font-size: 14px;
    height: 36px;
    line-height: 36px;

  }

  .height-s {
    font-size: 12px;
    height: 28px;
    line-height: 28px;
  }

  /** ---- **/

  .border-front {
    border: solid 1px $frontFormBorder;
  }

  .border-default {
    border: solid 1px #979797;
  }

</style>
